export default __webpack_public_path__ + "static/media/farm.ef8e6ad4.gif";